// extracted by mini-css-extract-plugin
export default {"wrapper":"payment-history_wrapper__mepuX"};